export default __webpack_public_path__ + "static/media/80350d0b615ff453937cded9ee19c171.png";